<template>
  <div class="page404">
    <div class="img404"><img src="../assets/img404.png" alt=""></div>
    <div class="imgoffline"><img src="../assets/img_offline.png" alt=""></div>
    <div class="text">{{ $t('page404.title') }}</div>
    <div class="text1">{{ $t('page404.text') }}</div>
    <div class="text1">{{ $t('page404.text1') }}</div>
    <div class="btn" @click="link_index">{{ $t('page404.btn') }}</div>
  </div>
</template>
<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch } from "vue"
  import { useRoute, useRouter } from 'vue-router'
  import { useI18n } from "vue-i18n";
  export default defineComponent({
    name: 'page404',
    setup() {
      const { t, locale } = useI18n();
      const router = useRouter()
      const link_index = () => {
        router.push({ path: '/' })
      }
      return {
        link_index
      };
    }
  })

</script>

<style lang="scss" scoped>
.page404 {
  width: 100%;
  display: flex;
  color: #fff;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: 500px;
  height: calc(100vh - 428px);
  .img404 {
    width: 40%;
    display: flex;
    overflow: hidden;
    max-width: 520px;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
    }
  }
  .imgoffline {
    width: 80%;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
    }
  }
  .text {
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .text1 {
    font-size: 16px;
    line-height: 24px;
  }
  .btn {
    cursor: pointer;
    font-size: 18px;
    margin-top: 20px;
    padding: 10px 20px;
    border-radius: 14px;
    background: linear-gradient(90deg, #8000FF 10%, #00FFD1 100%);
  }
}
</style>
